// 'modal-category-product-power-select
document.addEventListener('DOMContentLoaded', () => {
  const modal_category_product_power_select = document.getElementById('modal-category-product-power-select');
  const /** @type Modal */ m = window.Modal.getOrCreateInstance(modal_category_product_power_select);
  const power_select_buttons = modal_category_product_power_select.querySelectorAll('button');
  power_select_buttons.forEach((button) => {
    button.addEventListener('click', () => {
      //add to cart
      m.hide();
    });
  });
});